// import React, { useState } from 'react';

// const UnicodeTextConverters = () => {
//   const [input, setInput] = useState('');
//   const [output, setOutput] = useState('');
//   const [selectedConverter, setSelectedConverter] = useState('normal');


//   const handleInputChange = (e) => {
//     setInput(e.target.value);
//   };

//   const handleConverterChange = (e) => {
//     setSelectedConverter(e.target.value);
//   };

  
//       const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label
    
//       // Function to copy the strikethrough text to clipboard
//       const handleCopy = () => {
//         navigator.clipboard.writeText(output);
//         setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
//         setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
//       };

//   const handleConvert = () => {
//     let convertedText = input;

//     const converters = {
//       'normal': input,
//       'script': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x1D49C - 0x61)).join(''),
//       'boldScript': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x1D4D0 - 0x61)).join(''),
//       'fraktur': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x1D504 - 0x61)).join(''),
//       'circled': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x2460 - 0x31)).join(''),
//       'squared': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x1F130 - 0x41)).join(''),
//       'capitalized': input.toUpperCase(),
//       'fullWidth': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0xFF00 - 0x20)).join(''),
//       'monospace': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x1D670 - 0x61)).join(''),
//       'sansSerif': [...input].map(char => String.fromCodePoint(char.codePointAt(0) + 0x1D5A0 - 0x61)).join('')
//     };

//     convertedText = converters[selectedConverter] || input;
//     setOutput(convertedText);
//   };


//   const handleClear = () => {
//     setInput('');
//     setOutput('');
//     setSelectedConverter('');
//   };

//       // Function to calculate text statistics
//       const calculateTextStats = (text) => {
//         const totalCharacters = text.length;
//         const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
//         const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
//         const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
//         const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
    
//         return {
//           totalCharacters,
//           totalCharactersWithoutSpace,
//           totalWords,
//           totalParagraphs,
//           totalSentences,
//         };
//       };
    
    
//         // Calculate stats dynamically based on current binary value
//     const stats = calculateTextStats(input);

//   return (
//     <div className="container mt-5">

//         <div className="mb-3">
//           <label className="form-label">Input:
//           </label>
//           <textarea
//             className="form-control"
//             value={input}
//             onChange={handleInputChange}
//             rows={4}
//             placeholder="Enter text to convert:"
//           />
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Converter:</label>
//           <select
//             className="form-select"
//             value={selectedConverter}
//             onChange={handleConverterChange}
//           >
//             <option value="normal">Normal</option>
//             <option value="script">Script</option>
//             <option value="boldScript">Bold Script</option>
//             <option value="fraktur">Fraktur</option>
//             <option value="circled">Circled</option>
//             <option value="squared">Squared</option>
//             <option value="capitalized">Capitalized</option>
//             <option value="fullWidth">Full width</option>
//             <option value="monospace">Monospace</option>
//             <option value="sansSerif">Sans serif</option>
//           </select>
//           <button
//             className="btn btn-primary mt-3"
//             onClick={handleConvert}
//           >
//           Convert
//           </button>
//         </div>

//         <div className="mb-3">
//           <label className="form-label">Production </label>
//           <textarea
//             className="form-control"
//             value={output}
//             readOnly
//             rows={4}
//             style={{ height: '10rem' }}
//           />
//         </div>

//         <button className="btn btn-primary" onClick={handleCopy}>
//       {copyButtonLabel}
      
//             </button>

//         <button
//         className="btn btn-danger"
//         onClick={handleClear}
//       >
//      Clear
//       </button>

//         <div className="mt-3 text-muted">
//             <p>
//               Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
//             <p>
//                Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
//             </p>
//           </div>
      
//     </div>
//   );
// };

// export default UnicodeTextConverters;


import React, { useState } from "react";

const UnicodeTextConverters = () => {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [selectedConverter, setSelectedConverter] = useState("normal");
  const [copyButtonLabel, setCopyButtonLabel] = useState("Copy Text");

  const unicodeMaps = {
    script: {
      a: "𝒶", b: "𝒷", c: "𝒸", d: "𝒹", e: "𝑒", f: "𝒻", g: "𝑔", h: "𝒽", i: "𝒾", j: "𝒿",
      k: "𝓀", l: "𝓁", m: "𝓂", n: "𝓃", o: "𝑜", p: "𝓅", q: "𝓆", r: "𝓇", s: "𝓈", t: "𝓉",
      u: "𝓾", v: "𝓿", w: "𝓌", x: "𝓍", y: "𝓎", z: "𝓏",
      A: "𝒜", B: "𝐵", C: "𝒞", D: "𝒟", E: "𝐸", F: "𝐹", G: "𝒢", H: "𝐻", I: "𝒾", J: "𝒥",
      K: "𝒦", L: "𝐿", M: "𝑀", N: "𝒩", O: "𝒪", P: "𝒫", Q: "𝒬", R: "𝑅", S: "𝒮", T: "𝒯",
      U: "𝒰", V: "𝒱", W: "𝒲", X: "𝒳", Y: "𝒴", Z: "𝒵"
    },
    boldScript: {
      a: "𝓪", b: "𝓫", c: "𝓬", d: "𝓭", e: "𝓮", f: "𝓯", g: "𝓰", h: "𝓱", i: "𝓲", j: "𝓳",
      k: "𝓴", l: "𝓵", m: "𝓶", n: "𝓷", o: "𝓸", p: "𝓹", q: "𝓺", r: "𝓻", s: "𝓼", t: "𝓽",
      u: "𝓾", v: "𝓿", w: "𝔀", x: "𝔁", y: "𝔂", z: "𝔃",
      A: "𝓐", B: "𝓑", C: "𝓒", D: "𝓓", E: "𝓔", F: "𝓕", G: "𝓖", H: "𝓗", I: "𝓘", J: "𝓙",
      K: "𝓚", L: "𝓛", M: "𝓜", N: "𝓝", O: "𝓞", P: "𝓟", Q: "𝓠", R: "𝓡", S: "𝓢", T: "𝓣",
      U: "𝓤", V: "𝓥", W: "𝓦", X: "𝓧", Y: "𝓨", Z: "𝓩",
    },
    fraktur: {
      a: "𝔞", b: "𝔟", c: "𝔠", d: "𝔡", e: "𝔢", f: "𝔣", g: "𝔤", h: "𝔥", i: "𝔦", j: "𝔧",
      k: "𝔨", l: "𝔩", m: "𝔪", n: "𝔫", o: "𝔬", p: "𝔭", q: "𝔮", r: "𝔯", s: "𝔰", t: "𝔱",
      u: "𝔲", v: "𝔳", w: "𝔴", x: "𝔵", y: "𝔶", z: "𝔷",
      A: "𝔄", B: "𝔅", C: "ℭ", D: "𝔇", E: "𝔈", F: "𝔉", G: "𝔊", H: "ℌ", I: "ℑ", J: "𝔍",
      K: "𝔎", L: "𝔏", M: "𝔐", N: "𝔑", O: "𝔒", P: "𝔓", Q: "𝔔", R: "ℜ", S: "𝔖", T: "𝔗",
      U: "𝔘", V: "𝔙", W: "𝔚", X: "𝔛", Y: "𝔜", Z: "ℨ",
    },
    circled: {
      a: "ⓐ", b: "ⓑ", c: "ⓒ", d: "ⓓ", e: "ⓔ", f: "ⓕ", g: "ⓖ", h: "ⓗ", i: "ⓘ", j: "ⓙ",
      k: "ⓚ", l: "ⓛ", m: "ⓜ", n: "ⓝ", o: "ⓞ", p: "ⓟ", q: "ⓠ", r: "ⓡ", s: "ⓢ", t: "ⓣ",
      u: "ⓤ", v: "ⓥ", w: "ⓦ", x: "ⓧ", y: "ⓨ", z: "ⓩ",
      A: "Ⓐ", B: "Ⓑ", C: "Ⓒ", D: "Ⓓ", E: "Ⓔ", F: "Ⓕ", G: "Ⓖ", H: "Ⓗ", I: "Ⓘ", J: "Ⓙ",
      K: "Ⓚ", L: "Ⓛ", M: "Ⓜ", N: "Ⓝ", O: "Ⓞ", P: "Ⓟ", Q: "Ⓠ", R: "Ⓡ", S: "Ⓢ", T: "Ⓣ",
      U: "Ⓤ", V: "Ⓥ", W: "Ⓦ", X: "Ⓧ", Y: "Ⓨ", Z: "Ⓩ",
    },
    squared: {
      a: "🄰", b: "🄱", c: "🄲", d: "🄳", e: "🄴", f: "🄵", g: "🄶", h: "🄷", i: "🄸", j: "🄹",
      k: "🄺", l: "🄻", m: "🄼", n: "🄽", o: "🄾", p: "🄿", q: "🅀", r: "🅁", s: "🅂", t: "🅃",
      u: "🅄", v: "🅅", w: "🅆", x: "🅇", y: "🅈", z: "🅉",
      A: "🄰", B: "🄱", C: "🄲", D: "🄳", E: "🄴", F: "🄵", G: "🄶", H: "🄷", I: "🄸", J: "🄹",
      K: "🄺", L: "🄻", M: "🄼", N: "🄽", O: "🄾", P: "🄿", Q: "🅀", R: "🅁", S: "🅂", T: "🅃",
      U: "🅄", V: "🅅", W: "🅆", X: "🅇", Y: "🅈", Z: "🅉",
    },
    capitalized: {
      a: "A", b: "B", c: "C", d: "D", e: "E", f: "F", g: "G", h: "H", i: "I", j: "J",
      k: "K", l: "L", m: "M", n: "N", o: "O", p: "P", q: "Q", r: "R", s: "S", t: "T",
      u: "U", v: "V", w: "W", x: "X", y: "Y", z: "Z",
      A: "A", B: "B", C: "C", D: "D", E: "E", F: "F", G: "G", H: "H", I: "I", J: "J",
      K: "K", L: "L", M: "M", N: "N", O: "O", P: "P", Q: "Q", R: "R", S: "S", T: "T",
      U: "U", V: "V", W: "W", X: "X", Y: "Y", Z: "Z",
    },
    fullWidth: {
      a: "ａ", b: "ｂ", c: "ｃ", d: "ｄ", e: "ｅ", f: "ｆ", g: "ｇ", h: "ｈ", i: "ｉ", j: "ｊ",
      k: "ｋ", l: "ｌ", m: "ｍ", n: "ｎ", o: "ｏ", p: "ｐ", q: "ｑ", r: "ｒ", s: "ｓ", t: "ｔ",
      u: "ｕ", v: "ｖ", w: "ｗ", x: "ｘ", y: "ｙ", z: "ｚ",
      A: "Ａ", B: "Ｂ", C: "Ｃ", D: "Ｄ", E: "Ｅ", F: "Ｆ", G: "Ｇ", H: "Ｈ", I: "Ｉ", J: "Ｊ",
      K: "Ｋ", L: "Ｌ", M: "Ｍ", N: "Ｎ", O: "Ｏ", P: "Ｐ", Q: "Ｑ", R: "Ｒ", S: "Ｓ", T: "Ｔ",
      U: "Ｕ", V: "Ｖ", W: "Ｗ", X: "Ｘ", Y: "Ｙ", Z: "Ｚ",
    },
    sansSerif: {
      a: "𝖺", b: "𝖻", c: "𝖼", d: "𝖽", e: "𝖾", f: "𝖿", g: "𝗀", h: "𝗁", i: "𝗂", j: "𝗃",
      k: "𝗄", l: "𝗅", m: "𝗆", n: "𝗇", o: "𝗈", p: "𝗉", q: "𝗊", r: "𝗋", s: "𝗌", t: "𝗍",
      u: "𝗎", v: "𝗏", w: "𝗐", x: "𝗑", y: "𝗒", z: "𝗓",
      A: "𝖠", B: "𝖡", C: "𝖢", D: "𝖣", E: "𝖤", F: "𝖥", G: "𝖦", H: "𝖧", I: "𝖨", J: "𝖩",
      K: "𝖪", L: "𝖫", M: "𝖬", N: "𝖭", O: "𝖮", P: "𝖯", Q: "𝖰", R: "𝖱", S: "𝖲", T: "𝖳",
      U: "𝖴", V: "𝖵", W: "𝖶", X: "𝖷", Y: "𝖸", Z: "𝖹",
    },
    monospace: {
      a: "𝚊", b: "𝚋", c: "𝚌", d: "𝚍", e: "𝚎", f: "𝚏", g: "𝚐", h: "𝚑", i: "𝚒", j: "𝚓",
      k: "𝚔", l: "𝚕", m: "𝚖", n: "𝚗", o: "𝚘", p: "𝚙", q: "𝚚", r: "𝚛", s: "𝚜", t: "𝚝",
      u: "𝚞", v: "𝚟", w: "𝚠", x: "𝚡", y: "𝚢", z: "𝚣",
      A: "𝙰", B: "𝙱", C: "𝙲", D: "𝙳", E: "𝙴", F: "𝙵", G: "𝙶", H: "𝙷", I: "𝙸", J: "𝙹",
      K: "𝙺", L: "𝙻", M: "𝙼", N: "𝙽", O: "𝙾", P: "𝙿", Q: "𝚀", R: "𝚁", S: "𝚂", T: "𝚃",
      U: "𝚄", V: "𝚅", W: "𝚆", X: "𝚇", Y: "𝚈", Z: "𝚉",
    },
    normal: {
      a: "a", b: "b", c: "c", d: "d", e: "e", f: "f", g: "g", h: "h", i: "i", j: "j",
      k: "k", l: "l", m: "m", n: "n", o: "o", p: "p", q: "q", r: "r", s: "s", t: "t",
      u: "u", v: "v", w: "w", x: "x", y: "y", z: "z",
      A: "A", B: "B", C: "C", D: "D", E: "E", F: "F", G: "G", H: "H", I: "I", J: "J",
      K: "K", L: "L", M: "M", N: "N", O: "O", P: "P", Q: "Q", R: "R", S: "S", T: "T",
      U: "U", V: "V", W: "W", X: "X", Y: "Y", Z: "Z",
    },
  };

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const handleConverterChange = (e) => {
    setSelectedConverter(e.target.value);
  };

  const handleConvert = () => {
    const map = unicodeMaps[selectedConverter];
    const convertedText = inputText
      .split("")
      .map((char) => map[char] || char)
      .join("");
    setOutputText(convertedText);
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(outputText)
      .then(() => {
        setCopyButtonLabel("Copied!");
        setTimeout(() => setCopyButtonLabel("Copy Text"), 1500);
      })
      .catch(() => alert("Failed to copy text."));
  };

  const handleClear = () => {
    setInputText("");
    setOutputText("");
    setSelectedConverter("normal");
  };

  const calculateTextStats = (text) => {
    const totalCharacters = text.length;
    const totalCharactersWithoutSpace = text.replace(/\s+/g, "").length;
    const totalWords = text.trim() === "" ? 0 : text.trim().split(/\s+/).length;
    const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
    const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;

    return {
      totalCharacters,
      totalCharactersWithoutSpace,
      totalWords,
      totalParagraphs,
      totalSentences,
    };
  };

  const stats = calculateTextStats(inputText);

  return (
    <div className="container mt-5">
      <div className="mb-3">
        <label className="form-label">Input:</label>
        <textarea
          className="form-control"
          value={inputText}
          onChange={handleInputChange}
          rows={4}
          placeholder="Enter text to convert:"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Converter:</label>
        <select
          className="form-select"
          value={selectedConverter}
          onChange={handleConverterChange}
        >
          <option value="normal">Normal</option>
          <option value="script">Script</option>
          <option value="boldScript">Bold Script</option>
          <option value="fraktur">Fraktur</option>
          <option value="circled">Circled</option>
          <option value="squared">Squared</option>
          <option value="capitalized">Capitalized</option>
          <option value="fullWidth">Full width</option>
          <option value="sansSerif">Sans serif</option>
          <option value="monospace">Monospace</option>
        </select>
        <button className="btn btn-primary mt-3" onClick={handleConvert}>
          Convert
        </button>
      </div>

      <div className="mb-3">
        <label className="form-label">Output:</label>
        <textarea
            className="form-control"
            value={outputText}
            readOnly
            rows={4}
            style={{ height: '10rem' }}
          />
        </div>

        <button className="btn btn-primary" onClick={handleCopy}>
      {copyButtonLabel}
      
            </button>

        <button
        className="btn btn-danger"
        onClick={handleClear}
      >
     Clear
      </button>

        <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
      
    </div>
  );
};

export default UnicodeTextConverters;













